export default "__VITE_ASSET__tpsdEbjI__";